import { AuthClientConfig } from '@auth0/auth0-angular';
import { AppConfig } from './app-config';

export function initializeAuth0Client(authClientConfig: AuthClientConfig, appConfig: AppConfig) {
  return () => {
    authClientConfig.set({
      authorizationParams: {
        audience: appConfig.auth0.audience,
        redirect_uri: `${window.location.origin}/callback`,
        scope: appConfig.auth0.scope,
      },
      clientId: appConfig.auth0.clientID,
      domain: appConfig.auth0.domain,
      httpInterceptor: {
        allowedList: [
          // Be careful when refactoring this so that starting the app locally and connecting to QA still works.
          appConfig.baseApiUrl + '*',
          appConfig.newApiUrl + '*',
        ],
      },
    });
  };
}
